import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RestApi} from '../../../auth/rest.api';
import {AdvancedCleaningOption} from './cleaning-option.enum';
import { IJobData } from './job-data.interface';
import { retry } from 'rxjs/operators';

const baseUrlExt = 'api/Maintenance/';

@Injectable()
export class MaintenanceService {

  constructor(
    private http: HttpClient,
    private _api: RestApi
  ) { }

  getStateMaintenanceWindow() {
    return this._api
      .get(baseUrlExt + 'GetStateMaintenanceWindow');
  }

  getProgressMaintenanceWindow() {
    return this._api
      .get(baseUrlExt + 'GetProgressMaintenanceWindow');
  }

  getCleanCasesJobData(){
    return this._api
      .get(baseUrlExt + 'GetCleanCasesJobData');
    }
    
  getRestartWebApps(){
    return this._api
      .get(baseUrlExt + 'RestartWebApps');
  }

  getRestartWebAppsState(){
    return this._api
      .get(baseUrlExt + 'GetRestartWebAppsState');
  }

  showFullServiceRestart(){
    return this._api
      .get(baseUrlExt + 'ShowFullServiceRestart');
  }
  
  getCheckWebApps(){
    return this._api
      .get(baseUrlExt + 'CheckWebApps').pipe(
        retry(1)
      );
  }

  turnOnMaintenance() {
    return this._api
      .post(baseUrlExt + 'TurnOnMaintenanceWindow', '');
  }

  turnOffMaintenance() {
    return this._api
      .post(baseUrlExt + 'TurnOffMaintenanceWindow', '');
  }

  customCleaningOptions(cleaningOptions: AdvancedCleaningOption[] = [AdvancedCleaningOption.All, AdvancedCleaningOption.Connector]) {
    return this._api
      .post(baseUrlExt + 'AdvancedCleaningMaintenanceWindow', cleaningOptions);
  }

  updateCleanCasesJobData(jobData: IJobData) {
    return this._api
      .post(baseUrlExt + 'UpdateCleanCasesJobData', jobData);
  }


}
